import React from 'react';
import { useI18n } from '@oneaudi/i18n-context';
import { Tag, Headline, Text } from '@oneaudi/unified-web-components';
import { FeaturesListWrapper, KeyFeaturesContainer } from './styles/CarinfoWrapper.styles';
import { DynamicComponent, mapButtonTypeToIconName, resolvePlaceholder } from '../../utils';
import { useServicesContext } from '../../../context';
import { useDescription } from '../../../hooks';
import { DangerousElement, FootnoteReference } from '../../../components';
export const KeyFeaturesWrapper = ({ isPlp, vehicle, vehicleDetail, }) => {
    var _a, _b;
    const audiContentService = useServicesContext().getAdditionalService('audi-content-service');
    const content = audiContentService.getContent();
    const vtpConfig = (_b = (_a = content === null || content === void 0 ? void 0 : content.fields) === null || _a === void 0 ? void 0 : _a.vtpConfiguration) === null || _b === void 0 ? void 0 : _b.fields;
    const highlightItems = vtpConfig === null || vtpConfig === void 0 ? void 0 : vtpConfig.highlightItems;
    const keyFeaturesHeading = useI18n({
        id: 'nemo.ui.sc.details.keyFeatures',
        defaultMessage: 'Key Features',
    });
    return (React.createElement(KeyFeaturesContainer, { isPLP: isPlp },
        !isPlp && (React.createElement(DynamicComponent, { legacy: React.createElement(Headline, { tag: "h3", variant: {
                    order: '4',
                    type: 'headline',
                    weight: 'normal',
                } }, keyFeaturesHeading), alpha: React.createElement(Text, { tag: "p", variant: {
                    order: '1',
                    style: 'normal',
                } }, keyFeaturesHeading) })),
        React.createElement(FeaturesListWrapper, { isPLP: isPlp }, highlightItems &&
            highlightItems.length > 0 &&
            highlightItems.map((item) => {
                const list = item.fields;
                const iconNameFromConfig = list.IconName;
                const iconName = iconNameFromConfig || mapButtonTypeToIconName(list.TechdataKey);
                const [_labelText, descriptionText] = useDescription(list.IconLabel || '', list.TechdataKey, vehicle, vehicleDetail);
                const ariaLabel = useI18n({
                    id: `stockcars.${list.TechdataKey}.arialabel`,
                    defaultMessage: '',
                });
                const labelAriaToRender = ariaLabel.replace('{{value}}', descriptionText);
                if (descriptionText) {
                    return (React.createElement(Tag, { icon: iconName, size: "sm", key: list.TechdataKey, label: React.createElement("div", null,
                            React.createElement(DangerousElement, { as: "span", html: descriptionText }),
                            React.createElement(FootnoteReference, { refId: resolvePlaceholder(list === null || list === void 0 ? void 0 : list.FootNote, vehicle) })), variant: "read-only", "aria-label": labelAriaToRender }));
                }
                return '';
            }))));
};
